import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core'

@Component({
  selector: 'dmmp-banner-item-content',
  templateUrl: './banner-item-content.component.html'
})
export class BannerItemContentComponent implements OnInit {

  @Input() relatedContent
  @Input() externContent: any[]
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()

  content: any[]

  constructor() {
  }

  ngOnInit(): void {
    this.content = this.relatedContent
    this.externContent?.forEach(item => {
      item?.columns?.forEach(column => {
        if (column?.in_related_content === true) {
          this.content = [...this.content, column]
        }
      })
    })
  }

}
